import type { FC } from 'react';
import { Divider } from 'src/components/dividers';
import { Container } from 'src/components/layout/container';
import { Logo } from 'src/components/media-and-icons/logo';
import { ExternalLink, Link } from 'src/components/navigation/link';
import { AngularModalDimmer } from 'src/components/overlay/angular-modal-dimmer';
import { Heading } from 'src/components/text/heading';
import { useNow } from 'src/hooks/use-now';

export const Footer: FC = () => {
  const now = new Date(useNow());
  return (
    <AngularModalDimmer>
      <div className="bg-legacy-brand">
        <Container ignoreFullwidth>
          <div
            className={`
              grid grid-cols-1 border-b border-legacy-brand-light-2
              md:grid-cols-[1fr_1fr]
              lg:grid-cols-[1.5fr_1fr_1fr_2.5fr]
            `}
          >
            <div>
              <div>
                <Logo />
              </div>
            </div>

            <div>
              <Heading mode="footer">Explore</Heading>
              <ul
                className={`
                  grid
                  [&_a]:text-legacy-brand-light-2
                  [&_a]:hover:text-legacy-brand-light-2
                  [&_a]:focus:text-legacy-brand-light-2
                `}
              >
                <li>
                  <ExternalLink
                    mode="inverse"
                    href="https://www.prisma-capacity.eu/"
                    target="_blank"
                  >
                    Company
                  </ExternalLink>
                </li>
                <li>
                  <ExternalLink
                    mode="inverse"
                    href="https://www.prisma-capacity.eu/services/"
                    target="_blank"
                  >
                    Services
                  </ExternalLink>
                </li>
                <li>
                  <ExternalLink
                    mode="inverse"
                    href="https://www.prisma-capacity.eu/careers/"
                    target="_blank"
                  >
                    Careers
                  </ExternalLink>
                </li>
                <li>
                  <ExternalLink
                    mode="inverse"
                    href="https://www.prisma-capacity.eu/news/"
                    target="_blank"
                  >
                    News
                  </ExternalLink>
                </li>
                <li>
                  <ExternalLink
                    mode="inverse"
                    href="https://www.prisma-capacity.eu/contact/"
                    target="_blank"
                  >
                    Contact
                  </ExternalLink>
                </li>
              </ul>
            </div>

            <div>
              <Heading mode="footer">Resources</Heading>
              <ul
                className={`
                  grid
                  [&_a]:text-legacy-brand-light-2
                  [&_a]:hover:text-legacy-brand-light-2
                  [&_a]:focus:text-legacy-brand-light-2
                `}
              >
                <li>
                  <Link
                    mode="inverse"
                    to="/market-messages/urgent-market-messages"
                  >
                    UMM
                  </Link>
                </li>
                <li>
                  <Link mode="inverse" to="/market-information/players/tsos">
                    Market Information
                  </Link>
                </li>
                <li>
                  <ExternalLink
                    mode="inverse"
                    href="https://www.prisma-capacity.eu/user-infos/"
                    target="_blank"
                  >
                    PRISMA Infos
                  </ExternalLink>
                </li>
                <li>
                  <ExternalLink
                    mode="inverse"
                    href="https://www.prisma-capacity.eu/downloads/"
                    target="_blank"
                  >
                    Downloads
                  </ExternalLink>
                </li>
                <li>
                  <ExternalLink
                    mode="inverse"
                    href="https://help.prisma-capacity.eu/support/solutions/36000117872"
                    target="_blank"
                  >
                    FAQ
                  </ExternalLink>
                </li>
              </ul>
            </div>

            <div>
              <Heading mode="footer">Stay Up to Date</Heading>

              <div
                className={`
                  grid items-center justify-items-start gap-xl
                  text-legacy-brand-light-2
                `}
              >
                <p>
                  Receive regular emails about the platform and the Gas Market,
                  surveys and invitations by subscribing to our newsletter. You
                  can unsubscribe at any time.
                </p>

                <ExternalLink
                  mode="button-inverse"
                  href="https://share-eu1.hsforms.com/1_R7051mYSPOn6s5Tbt6evA2dtk5s/"
                >
                  Subscribe
                </ExternalLink>
              </div>
            </div>
          </div>

          <div
            className={`
              grid grid-cols-1 items-center
              md:grid-flow-col md:justify-between
            `}
          >
            <div>
              <ExternalLink
                mode="button-inverse"
                href="https://help.prisma-capacity.eu/"
              >
                Support Portal
              </ExternalLink>
            </div>

            <div>
              <div
                className={`
                  grid grid-flow-col items-center gap-md
                  [&_a]:text-legacy-brand-light-2
                  [&_a]:hover:text-legacy-brand-light-2
                  [&_a]:focus:text-legacy-brand-light-2
                `}
              >
                <ExternalLink
                  mode="inverse"
                  href="https://www.prisma-capacity.eu/impressum/"
                  target="_blank"
                >
                  Imprint
                </ExternalLink>
                <Divider direction="vertical" className="h-[60%]" />
                <ExternalLink
                  mode="inverse"
                  href="https://www.prisma-capacity.eu/privacy/"
                  target="_blank"
                >
                  Privacy Policy
                </ExternalLink>
                <Divider direction="vertical" className="h-[60%]" />
                <ExternalLink
                  mode="inverse"
                  href="https://www.prisma-capacity.eu/platform-usage-contract-puc"
                  target="_blank"
                >
                  Platform Usage Conditions
                </ExternalLink>
                <Divider direction="vertical" className="h-[60%]" />
                <span className="text-legacy-brand-light-1">
                  Copyright @ PRISMA {now.getFullYear()}
                </span>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </AngularModalDimmer>
  );
};
